import React from "react";
import CustomTextField from "../../../common/InputField/Input";
import { TranslateText } from "../../../../utils/translation";

const SocialLinks = ({ localHotelDetailsState, setLocalHotelDetailsState }) => {
  const handleLinkChange = (value, title) => {
    const socialMediaLinks = localHotelDetailsState?.socialMediaLinks || [];

    const existingLinkIndex = socialMediaLinks.findIndex(
      (obj) => obj?.socialMediaName === title
    );

    let newLinkArray;

    if (existingLinkIndex !== -1) {
      newLinkArray = socialMediaLinks.map((obj, index) =>
        index !== existingLinkIndex
          ? obj
          : {
              ...obj,
              link: value,
            }
      );
    } else {
      const newLinkObj = {
        link: value,
        socialMediaName: title,
      };
      newLinkArray = [...socialMediaLinks, newLinkObj];
    }

    const newLocalState = {
      ...localHotelDetailsState,
      socialMediaLinks: newLinkArray,
    };
    setLocalHotelDetailsState(newLocalState);
  };

  return (
    <div className="pb-[5rem]">
      <header className="w-[100%] flex justify-between items-center font-body font-[500] text-[24px] leading-[30.34px] text-fg ">
        <TranslateText
                      textKey={"social_media_links"}
                      namespace="profile"
                    />  
      </header>

      <main className="flex flex-col gap-[34px] pt-[34px]">
        {[
          "google",
          "twitter",
          "instagram",
          "youtube",
          "linkedIn",
          "facebook",
        ]?.map((Obj) => {
          const dataObj = localHotelDetailsState?.socialMediaLinks?.filter(
            (currentObj) => currentObj?.socialMediaName === Obj
          )?.[0];

          return (
            <div key={Obj} className="flex justify-between items-center">
              <div
                className="capitalize w-[25%] font-body font-[400] text-[16px] 
                 leading-[24px]  tracking-[0.5px] text-fg "
              >
                {Obj}
              </div>

              <CustomTextField
                label=""
                isManadatory={false}
                value={Boolean(dataObj?.link) ? dataObj?.link : ""}
                onChange={(value) => handleLinkChange(value, Obj)}
                inputPaddingValue="8px"
                type="text"
                inputPadding={true}
              />
            </div>
          );
        })}
      </main>
    </div>
  );
};

export default SocialLinks;
